import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { User } from '../../_models/user';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { AudioPlayerService } from '../../services/audio-player.service';
import { SafeHtml } from '@angular/platform-browser';
import { GameService } from '../../services/game.service';
import { languageSwitchData } from '../../languages/languages';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.less']
})

export class LoginComponent implements OnInit, AfterViewInit {
    @ViewChild('inputName') inputName!: ElementRef<HTMLInputElement>;
    user: User = {
        username: '',
        password: ''
    };

    loading = false;
    errorMessage: SafeHtml = '';
    passwordMessage: String = '';
    login_welkomtekst: String = '';
    showColofon = false;
    colofonText: string = '';

    otherLanguage = languageSwitchData()

    constructor(
      private authService: AuthService,
      private router: Router,
      public audio: AudioPlayerService,
      private game: GameService) { }
  ngAfterViewInit(): void {
      this.inputName.nativeElement.focus();
  }

    ngOnInit() {
        // Play welcome text and afterwards play information about being new and how to register
        this.login_welkomtekst = this.audio.getPlay('login_welkomtekst',
            () => { this.audio.play('login_benjenieuwhier'); }
        );
        this.game.getColofon().subscribe(x => {
            this.colofonText = x;
        });

    }

    /**
     * Show and play the informatio where to find the username and password
     */
    forgotPassword() {
        this.errorMessage = '';
        this.passwordMessage = this.audio.getPlay('login_forgotPassword');
    }

    register() {
        this.router.navigate(['/register']);
    }
    enterUsername() {
        this.audio.play('login_gebruikernaam');
    }
    enterPassword() {
        this.audio.play('login_wachtwoord');
    }

    login() {
        // console.log('try login', this.loading);
        this.passwordMessage = '';
        this.loading = true;
        this.errorMessage = '';

        // Call the login service, go to dashboard on success, show error on failure
        this.authService.login(this.user.username, this.user.password).subscribe(
            (result) => {
                // console.log('login result', result);
                if (result === false) {
                  this.errorMessage = this.audio.getPlayHTML('login_passwordnotcorrect');
                    this.loading = false;
                }
                else if (result !== null) {
                    this.router.navigate(['/dashboard']);
                } else {
                    this.errorMessage = this.audio.getPlayHTML('login_passwordnotcorrect');
                    this.loading = false;
                }

            },
            error => {
                console.error('login error', this.user.username, error);
                this.errorMessage = this.audio.getPlayHTML('login_passwordnotcorrect');
                this.loading = false;
            },

        );
    }

    colofon() {
        this.showColofon = this.showColofon ? false : true;
    }

    DownloadManual() {
      const file = this.audio.getDownload('manual')
      if (file !== null) {
        // console.log(environment.staticUrl + file);
        window.open(environment.staticUrl + file);
      }
    }
}
